import Check from './Check';
import React from 'react';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { View } from 'react-native';

interface CheckFullIconProps {
  width?: number;
  height?: number;
  bgColor?: string;
  checkColor?: string;
}

const CheckFullIcon: React.FC<CheckFullIconProps> = ({
  width = 38,
  height = 38,
  bgColor = 'white',
  checkColor = '#FDFDFD',
}) => {
  const PADDING= SPACING['sp-4'];
  return (
    <View style={{ width, height,
      borderRadius: width / 2,
      padding:PADDING,

      backgroundColor:bgColor,alignItems: 'center',justifyContent: 'center'   }}>
      <Check width={width-2*PADDING} height={height-2*PADDING} color={checkColor} />
    </View>
  );
};

export default CheckFullIcon;
